import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "sentinel", "status"]
  static values = {
    url: String,
    nextPage: String
  }

  connect() {
    this.loading = false
    this.finished = !this.hasNextPageValue || this.nextPageValue === ""
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadMore()
        }
      })
    }, { rootMargin: "200px 0px" })

    if (this.hasSentinelTarget) {
      this.observer.observe(this.sentinelTarget)
    }

    this.updateStatus()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  async loadMore() {
    if (this.loading || this.finished || !this.hasUrlValue || !this.nextPageValue) {
      return
    }

    this.loading = true
    this.updateStatus("Loading more pages...")

    try {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("page", this.nextPageValue)

      const response = await fetch(url.toString(), {
        headers: { Accept: "application/json" }
      })

      if (!response.ok) {
        throw new Error(`Request failed (${response.status})`)
      }

      const data = await response.json()
      if (data.fonts_html) {
        document.head.insertAdjacentHTML("beforeend", data.fonts_html)
      }
      this.containerTarget.insertAdjacentHTML("beforeend", data.verses_html)
      this.nextPageValue = data.next_page ? String(data.next_page) : ""
      this.finished = !!data.finished || this.nextPageValue === ""
      this.updateStatus()
    } catch (error) {
      this.updateStatus("Unable to load more pages")
    } finally {
      this.loading = false
    }
  }

  updateStatus(message = null) {
    if (!this.hasStatusTarget) {
      return
    }

    if (message) {
      this.statusTarget.textContent = message
      return
    }

    if (this.finished) {
      this.statusTarget.textContent = "End of chapter"
    } else {
      this.statusTarget.textContent = "Scroll to load more pages"
    }
  }
}
